module.exports = __webpack_public_path__ + "static/media/operations_use_case_2.ee415944.svg";